import { CSSProperties } from 'react';

const styles = {
    avatarSelected: {
        paddingLeft: 16,
        paddingRight: 16,
        position: 'relative',
    } as CSSProperties,
    avatarUnselected: {
        paddingLeft: 16,
        paddingRight: 16,
        opacity: 0.5,
        position: 'relative',
        cursor: 'pointer',
    } as CSSProperties,
    avatarDisabledSelected: {
        paddingLeft: 16,
        paddingRight: 16,
        opacity: 0.4,
        position: 'relative',
    } as CSSProperties,
    avatarDisabledUnselected: {
        paddingLeft: 16,
        paddingRight: 16,
        opacity: 0.2,
        position: 'relative',
    } as CSSProperties,
};

export default styles;
